/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.13 public/models/oscorp_scene_cables.glb 
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

export function Model(props) {
  const { nodes, materials } = useGLTF("models/oscorp_scene_venom.glb");
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.LB_Small_Vent_2.geometry}
        material={materials["Dark Gray"]}
        position={[-2.793, -0.01, 0.162]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={0.037}
      />
      <mesh
        geometry={nodes.LB_Small_Vent_3.geometry}
        material={materials["Dark Gray"]}
        position={[-2.793, -0.01, 0.924]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={0.037}
      />
      <mesh
        geometry={nodes.LB_Small_Vent_1.geometry}
        material={materials["Dark Gray"]}
        position={[-2.793, -0.01, -0.6]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={0.037}
      />
      <group
        position={[-4.407, 0.007, 0.814]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[0.149, 0.004, 0.104]}
      >
        <mesh
          geometry={nodes.Cube083.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube083_1.geometry}
          material={materials["Darker Gray"]}
        />
      </group>
      <group
        position={[-4.798, 0.007, 0.814]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[0.149, 0.004, 0.104]}
        castShadow
      >
        <mesh
          geometry={nodes.Cube084.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube084_1.geometry}
          material={materials["Darker Gray"]}
        />
      </group>
      <group position={[-3.794, -1, -0.164]} rotation={[Math.PI, 0, Math.PI]}>
        <mesh
          geometry={nodes.Cube074.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube074_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube074_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <mesh
        geometry={nodes.LB_Wire.geometry}
        material={materials.Black}
        position={[-4.751, 0, -0.999]}
        rotation={[-Math.PI, 0.066, 0]}
        scale={[-0.048, -0.014, -0.011]}
      />
      <group
        position={[-4.022, 0.007, -1.242]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[0.149, 0.004, 0.104]}
      >
        <mesh
          geometry={nodes.Cube105.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube105_1.geometry}
          material={materials["Darker Gray"]}
        />
      </group>
      <group
        position={[-4.413, 0.007, -1.242]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[0.149, 0.004, 0.104]}
      >
        <mesh
          geometry={nodes.Cube106.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube106_1.geometry}
          material={materials["Darker Gray"]}
        />
      </group>
      <group
        position={[-3.242, 0.007, -1.242]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[0.149, 0.004, 0.104]}
      >
        <mesh
          geometry={nodes.Cube107.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube107_1.geometry}
          material={materials["Darker Gray"]}
        />
      </group>
      <group
        position={[-3.633, 0.007, -1.242]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[0.149, 0.004, 0.104]}
      >
        <mesh
          geometry={nodes.Cube108.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube108_1.geometry}
          material={materials["Darker Gray"]}
        />
      </group>
      <mesh
        geometry={nodes.Plane022.geometry}
        material={materials["Darker Gray"]}
        position={[0.656, 0.006, 1.018]}
        rotation={[0, -0.166, 0]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane023.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-1.147, 0.008, 1.25]}
        rotation={[-Math.PI, 0.246, -Math.PI]}
        scale={[0.059, 0.079, 0.079]}
      />
      <mesh
        geometry={nodes.Plane024.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-1.266, 0.003, 1.274]}
        rotation={[-Math.PI, 0.785, -Math.PI]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane025.geometry}
        material={materials["Blue Gray 1"]}
        position={[-0.679, 0.003, 1.242]}
        rotation={[Math.PI, -0.394, Math.PI]}
        scale={[0.063, 0.042, 0.054]}
      />
      <mesh
        geometry={nodes.Plane026.geometry}
        material={materials["Darker Gray"]}
        position={[-1.285, 0.003, 1.048]}
        rotation={[-Math.PI, 1.494, -Math.PI]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane027.geometry}
        material={materials["Darker Gray"]}
        position={[-0.127, 0.003, 1.141]}
        rotation={[Math.PI, -1.45, Math.PI]}
        scale={[0.043, 0.027, 0.075]}
      />
      <mesh
        geometry={nodes.Plane043.geometry}
        material={materials["Darker Gray"]}
        position={[-3.158, 0.006, 0.743]}
        rotation={[0, -0.685, 0]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane044.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-4.84, 0.008, 0.051]}
        rotation={[-Math.PI, 0.765, -Math.PI]}
        scale={[0.059, 0.079, 0.079]}
      />
      <mesh
        geometry={nodes.Plane045.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-4.954, 0.003, 0.014]}
        rotation={[-Math.PI, 1.304, -Math.PI]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane046.geometry}
        material={materials["Blue Gray 1"]}
        position={[-4.428, 0.003, 0.276]}
        rotation={[-Math.PI, 0.124, -Math.PI]}
        scale={[0.063, 0.042, 0.054]}
      />
      <mesh
        geometry={nodes.Plane047.geometry}
        material={materials["Darker Gray"]}
        position={[-3.899, 0.003, 0.462]}
        rotation={[Math.PI, -0.932, Math.PI]}
        scale={[0.043, 0.027, 0.075]}
      />
      <mesh
        geometry={nodes.Plane050.geometry}
        material={materials["Darker Gray"]}
        position={[-5.012, 0.003, 1.059]}
        rotation={[Math.PI, -0.932, Math.PI]}
        scale={[0.043, 0.027, 0.075]}
      />
      <mesh
        geometry={nodes.Plane052.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-4.839, 0.008, 1.076]}
        rotation={[0, -0.813, 0]}
        scale={[0.059, 0.079, 0.079]}
      />
      <mesh
        geometry={nodes.Plane053.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-4.673, 0.003, 1.11]}
        rotation={[0, -1.352, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane048.geometry}
        material={materials["Light Gray"]}
        position={[-3.39, 0.003, 0.559]}
        rotation={[0, 0.122, 0]}
        scale={[0.072, 0.07, 0.071]}
      />
      <mesh
        geometry={nodes.Plane049.geometry}
        material={materials["Blue Gray 1"]}
        position={[-3.937, 0.005, 0.381]}
        rotation={[Math.PI, -0.85, Math.PI]}
        scale={[0.041, 0.027, 0.035]}
      />
      <mesh
        geometry={nodes.Plane051.geometry}
        material={materials["Blue Gray 1"]}
        position={[-5.05, 0.005, 0.978]}
        rotation={[Math.PI, -0.85, Math.PI]}
        scale={[0.041, 0.027, 0.035]}
      />
      <mesh
        geometry={nodes.Plane054.geometry}
        material={materials["Dirty Purple 1"]}
        position={[-2.909, 0.003, -1.288]}
        rotation={[0, -0.575, 0]}
        scale={[0.035, 0.047, 0.047]}
      />
      <mesh
        geometry={nodes.Plane055.geometry}
        material={materials.Black}
        position={[-2.721, 0.003, -1.282]}
        rotation={[0, -0.036, 0]}
        scale={[0.065, 0.087, 0.087]}
      />
      <mesh
        geometry={nodes.Plane056.geometry}
        material={materials.Black}
        position={[-2.544, 0.008, -1.332]}
        rotation={[0, -0.575, 0]}
        scale={[0.043, 0.058, 0.058]}
      />
      <mesh
        geometry={nodes.Plane057.geometry}
        material={materials["Dirty Purple 2"]}
        position={[-2.594, 0.003, -1.082]}
        rotation={[0, 0.604, 0]}
        scale={[0.05, 0.033, 0.043]}
      />
      <mesh
        geometry={nodes.Plane058.geometry}
        material={materials["Dark Gray"]}
        position={[-2.79, 0.006, -1.106]}
        rotation={[0, -1.284, 0]}
        scale={[0.035, 0.047, 0.047]}
      />
      <mesh
        geometry={nodes.RB_Small_Exhaust_2.geometry}
        material={materials["Darker Gray"]}
        position={[4.814, -0.002, 0.981]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={[-0.11, -0.008, -0.11]}
      />
      <mesh
        geometry={nodes.RB_Small_Exhaust_1.geometry}
        material={materials["Darker Gray"]}
        position={[4.814, -0.002, 0.314]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={[-0.11, -0.008, -0.11]}
      />
      <group position={[4.948, -0.018, -1.163]} scale={[0.094, 0.119, 0.094]}>
        <mesh
          geometry={nodes.Cylinder004_1.geometry}
          material={materials.Black}
        />
        <mesh
          geometry={nodes.Cylinder004_2.geometry}
          material={materials["Darker Gray"]}
        />
      </group>
      <mesh
        geometry={nodes.RB_Satellite_Tower.geometry}
        material={materials.Black}
        position={[2.784, 0.353, -1.165]}
        rotation={[-Math.PI, 0.991, -Math.PI]}
        scale={[-0.018, -0.11, -0.004]}
      />
      <mesh
        geometry={nodes.RB_Wire.geometry}
        material={materials.Black}
        position={[2.804, 0, -1.109]}
        rotation={[Math.PI, -1.072, 0]}
        scale={[-0.048, -0.014, -0.011]}
      />
      <group
        position={[2.834, -0.306, 0.971]}
        rotation={[0, Math.PI / 2, 0]}
        scale={0.587}
      >
        <mesh
          geometry={nodes.Cube085.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube085_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube085_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <group
        position={[2.834, -0.306, 0.423]}
        rotation={[0, Math.PI / 2, 0]}
        scale={0.587}
      >
        <mesh
          geometry={nodes.Cube086.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube086_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube086_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <group position={[3.773, -1, 0]}>
        <mesh
          geometry={nodes.Cube078.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube078_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube078_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <mesh
        geometry={nodes.Plane028.geometry}
        material={materials["Darker Gray"]}
        position={[3.416, 0.006, 1.048]}
        rotation={[0, -0.74, 0]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane029.geometry}
        material={materials["Dirty Beige 2"]}
        position={[3.615, 0.003, 0.694]}
        rotation={[0, -0.574, 0]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane035.geometry}
        material={materials["Light Gray"]}
        position={[3.226, 0.003, 0.884]}
        rotation={[0, 0.066, 0]}
        scale={[0.072, 0.07, 0.071]}
      />
      <mesh
        geometry={nodes.Plane036.geometry}
        material={materials["Dirty Beige 2"]}
        position={[4.166, 0.006, 0.826]}
        rotation={[0, 0.066, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane037.geometry}
        material={materials["Dirty Purple 1"]}
        position={[4.267, 0.003, -0.759]}
        rotation={[0, 0.997, 0]}
        scale={[0.059, 0.079, 0.079]}
      />
      <mesh
        geometry={nodes.Plane038.geometry}
        material={materials["Darker Gray"]}
        position={[4.14, 0.003, -0.973]}
        rotation={[0, 0.83, 0]}
        scale={[0.06, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane039.geometry}
        material={materials["Dirty Beige 1"]}
        position={[4.621, 0.003, -0.509]}
        rotation={[0, -0.251, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane040.geometry}
        material={materials["Dirty Beige 2"]}
        position={[4.023, 0.006, 0.207]}
        rotation={[0, -0.902, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane041.geometry}
        material={materials["Dirty Beige 2"]}
        position={[3.607, 0.003, -0.576]}
        rotation={[0, -0.574, 0]}
        scale={[0.063, 0.085, 0.085]}
      />
      <mesh
        geometry={nodes.Plane042.geometry}
        material={materials["Dirty Beige 2"]}
        position={[3.551, 0.006, 0.94]}
        rotation={[0, -0.574, 0]}
        scale={[0.051, 0.069, 0.069]}
      />
      <group position={[0, -1, 0]}>
        <mesh
          geometry={nodes.Cube002.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube002_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube002_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <group
        position={[-0.844, -0.306, -0.973]}
        rotation={[0, Math.PI / 2, 0]}
        scale={0.587}
      >
        <mesh
          geometry={nodes.Cube012.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube012_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube012_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <group
        position={[-0.844, -0.306, 0.971]}
        rotation={[0, Math.PI / 2, 0]}
        scale={0.587}
      >
        <mesh
          geometry={nodes.Cube013.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube013_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube013_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <mesh
        geometry={nodes.MB_Small_Vent_1.geometry}
        material={materials["Dark Gray"]}
        position={[1, 0, -1]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={0.037}
      />
      <mesh
        geometry={nodes.MB_Small_Vent_3.geometry}
        material={materials["Darker Gray"]}
        position={[1, 0, 1]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={0.037}
      />
      <mesh
        geometry={nodes.MB_Wire_2.geometry}
        material={materials.Black}
        position={[0.319, 0, 0.474]}
        scale={[0.048, 0.014, 0.011]}
      />
      <mesh
        geometry={nodes.MB_Wire_1.geometry}
        material={materials.Black}
        position={[0.555, 0, 0.11]}
        rotation={[Math.PI, -1.072, 0]}
        scale={[-0.048, -0.014, -0.011]}
      />
      <mesh
        geometry={nodes.MB_Small_Vent_2.geometry}
        material={materials["Darker Gray"]}
        position={[1, 0, 0.24]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={0.037}
      />
      <mesh
        geometry={nodes.Plane.geometry}
        material={materials["Dirty Beige 2"]}
        position={[0.63, 0.003, 0.773]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane001.geometry}
        material={materials["Dirty Beige 1"]}
        position={[0.828, 0.003, 0.734]}
        rotation={[0, -0.539, 0]}
        scale={[0.073, 0.099, 0.099]}
      />
      <mesh
        geometry={nodes.Plane002.geometry}
        material={materials["Darker Gray"]}
        position={[0.656, 0.006, 1.018]}
        rotation={[0, -0.166, 0]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane003.geometry}
        material={materials["Light Gray"]}
        position={[0.363, 0.003, 0.974]}
        rotation={[0, 0.64, 0]}
        scale={[0.072, 0.07, 0.071]}
      />
      <mesh
        geometry={nodes.Plane004.geometry}
        material={materials["Dirty Beige 2"]}
        position={[0.906, 0.006, 0.828]}
        rotation={[0, 0.64, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane005.geometry}
        material={materials["Dirty Purple 1"]}
        position={[0.238, 0.003, -0.703]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[0.059, 0.079, 0.079]}
      />
      <mesh
        geometry={nodes.Plane006.geometry}
        material={materials["Dirty Purple 1"]}
        position={[0.492, 0.003, -0.768]}
        rotation={[0, 1.032, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane007.geometry}
        material={materials["Darker Gray"]}
        position={[0.166, 0.003, -0.911]}
        rotation={[0, 1.404, 0]}
        scale={[0.06, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane008.geometry}
        material={materials["Light Gray"]}
        position={[0.697, 0.003, -0.39]}
        rotation={[-Math.PI, 0.93, -Math.PI]}
        scale={[0.043, 0.042, 0.042]}
      />
      <mesh
        geometry={nodes.Plane009.geometry}
        material={materials["Dirty Beige 2"]}
        position={[1.138, 0.003, -0.692]}
        rotation={[-Math.PI, 0.93, -Math.PI]}
        scale={[0.063, 0.042, 0.054]}
      />
      <mesh
        geometry={nodes.Plane010.geometry}
        material={materials["Darker Gray"]}
        position={[0.83, 0.003, -0.383]}
        rotation={[-Math.PI, 1.465, -Math.PI]}
        scale={[0.029, 0.028, 0.029]}
      />
      <mesh
        geometry={nodes.Plane011.geometry}
        material={materials["Dirty Beige 1"]}
        position={[0.822, 0.003, -0.784]}
        rotation={[0, 0.323, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane012.geometry}
        material={materials.Black}
        position={[0.634, 0.003, -1.035]}
        rotation={[0, Math.PI / 2, 0]}
        scale={[0.059, 0.079, 0.079]}
      />
      <mesh
        geometry={nodes.Plane013.geometry}
        material={materials.Black}
        position={[0.652, 0.009, -1.138]}
        rotation={[0, 1.032, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane014.geometry}
        material={materials["Dirty Purple 2"]}
        position={[0.737, 0.003, -1.174]}
        rotation={[-Math.PI, 0.93, -Math.PI]}
        scale={[0.063, 0.042, 0.054]}
      />
      <mesh
        geometry={nodes.Plane015.geometry}
        material={materials["Dark Gray"]}
        position={[0.68, 0.006, -1.221]}
        rotation={[0, 0.323, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane016.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-1.147, 0.008, 1.25]}
        rotation={[-Math.PI, 0.246, -Math.PI]}
        scale={[0.059, 0.079, 0.079]}
      />
      <mesh
        geometry={nodes.Plane017.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-1.266, 0.003, 1.274]}
        rotation={[-Math.PI, 0.785, -Math.PI]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane018.geometry}
        material={materials["Blue Gray 1"]}
        position={[-0.679, 0.003, 1.242]}
        rotation={[Math.PI, -0.394, Math.PI]}
        scale={[0.063, 0.042, 0.054]}
      />
      <mesh
        geometry={nodes.Plane019.geometry}
        material={materials["Darker Gray"]}
        position={[-1.285, 0.003, 1.048]}
        rotation={[-Math.PI, 1.494, -Math.PI]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane020.geometry}
        material={materials["Blue Gray 1"]}
        position={[-0.2, 0.005, 1.089]}
        rotation={[Math.PI, -1.368, Math.PI]}
        scale={[0.041, 0.027, 0.035]}
      />
      <mesh
        geometry={nodes.Plane021.geometry}
        material={materials["Darker Gray"]}
        position={[-0.127, 0.003, 1.141]}
        rotation={[Math.PI, -1.45, Math.PI]}
        scale={[0.043, 0.027, 0.075]}
      />
      <mesh
        geometry={nodes.Plane030.geometry}
        material={materials["Light Gray"]}
        position={[-3.096, -0.061, 0.61]}
        rotation={[-Math.PI, 0.93, -Math.PI]}
        scale={[0.043, 0.042, 0.042]}
      />
      <mesh
        geometry={nodes.Plane031.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-2.971, -0.061, 0.216]}
        rotation={[0, 0.323, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane032.geometry}
        material={materials.Black}
        position={[2.919, -0.06, -0.801]}
        rotation={[-Math.PI, 1.268, -Math.PI]}
        scale={[0.059, 0.079, 0.079]}
      />
      <mesh
        geometry={nodes.Plane033.geometry}
        material={materials.Black}
        position={[2.716, -0.054, -0.895]}
        rotation={[0, 1.032, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane034.geometry}
        material={materials["Dark Gray"]}
        position={[2.835, -0.057, -1.064]}
        rotation={[0, 0.323, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane059.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-1.072, 0.003, -0.185]}
        rotation={[0, -0.229, 0]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane060.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-0.938, 0.012, -0.173]}
        rotation={[0, -0.768, 0]}
        scale={[0.073, 0.099, 0.099]}
      />
      <mesh
        geometry={nodes.Plane061.geometry}
        material={materials["Light Gray"]}
        position={[-1.156, 0.003, 0.181]}
        rotation={[0, 0.411, 0]}
        scale={[0.072, 0.07, 0.071]}
      />
      <group position={[-15.603, -11.06, -23.333]} scale={2.035}>
        <mesh
          geometry={nodes.Cube034.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube034_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube034_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <group position={[-15.603, -5.909, -30.819]} scale={2.035}>
        <mesh
          geometry={nodes.Cube050.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube050_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube050_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <group position={[-8.217, -3.673, -7.681]} scale={1.58}>
        <mesh
          geometry={nodes.Cube088.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube088_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube088_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <group position={[-23.772, -9.485, -23.275]} scale={2.035}>
        <mesh
          geometry={nodes.Cube089.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube089_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube089_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <group position={[-7.309, -1.012, -9.277]} scale={[0.064, 0.017, 0.241]}>
        <mesh
          geometry={nodes.Cube077.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube077_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh geometry={nodes.Cube077_2.geometry} material={materials.Blue} />
        <mesh
          geometry={nodes.Cube077_3.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube077_4.geometry}
          material={materials["Dark Grayer"]}
        />
        <mesh
          geometry={nodes.Cube077_5.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh geometry={nodes.Cube077_6.geometry} material={materials.Red} />
        <mesh
          geometry={nodes.Cube077_7.geometry}
          material={materials["Dark Blue"]}
        />
      </group>
      <mesh
        geometry={nodes.Lab_Logo.geometry}
        material={materials["Darker Gray"]}
        position={[-9.193, -1.129, -12.058]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[-0.003, -0.005, -0.007]}
      />
      <mesh
        geometry={nodes.Plane062.geometry}
        material={materials["Darker Gray"]}
        position={[-8.735, -2.082, -5.815]}
        rotation={[0, -0.166, 0]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane063.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-9.945, -2.08, -7.279]}
        rotation={[-Math.PI, 0.246, -Math.PI]}
        scale={[0.059, 0.079, 0.079]}
      />
      <mesh
        geometry={nodes.Plane064.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-10.064, -2.085, -7.255]}
        rotation={[-Math.PI, 0.785, -Math.PI]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane065.geometry}
        material={materials["Darker Gray"]}
        position={[-10.083, -2.085, -7.481]}
        rotation={[-Math.PI, 1.494, -Math.PI]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane066.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-8.761, -2.085, -6.06]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane067.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-8.563, -2.085, -6.099]}
        rotation={[0, -0.539, 0]}
        scale={[0.073, 0.099, 0.099]}
      />
      <mesh
        geometry={nodes.Plane068.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-8.485, -2.082, -6.005]}
        rotation={[0, 0.64, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane069.geometry}
        material={materials["Darker Gray"]}
        position={[-9.225, -2.085, -7.744]}
        rotation={[0, 1.404, 0]}
        scale={[0.06, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane070.geometry}
        material={materials["Light Gray"]}
        position={[-8.694, -2.085, -7.223]}
        rotation={[-Math.PI, 0.93, -Math.PI]}
        scale={[0.043, 0.042, 0.042]}
      />
      <mesh
        geometry={nodes.Plane071.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-8.569, -2.085, -7.617]}
        rotation={[0, 0.323, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane072.geometry}
        material={materials.Black}
        position={[-8.739, -2.079, -7.971]}
        rotation={[0, 1.032, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane073.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-9.182, -2.085, -9.403]}
        rotation={[0, -0.229, 0]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane074.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-9.048, -2.076, -9.39]}
        rotation={[0, -0.768, 0]}
        scale={[0.073, 0.099, 0.099]}
      />
      <mesh
        geometry={nodes.Plane075.geometry}
        material={materials["Light Gray"]}
        position={[-9.266, -2.085, -9.036]}
        rotation={[0, 0.411, 0]}
        scale={[0.072, 0.07, 0.071]}
      />
      <mesh
        geometry={nodes.Plane076.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-8.11, -2.08, -6.642]}
        rotation={[Math.PI, -0.654, Math.PI]}
        scale={[0.059, 0.079, 0.079]}
      />
      <mesh
        geometry={nodes.Plane077.geometry}
        material={materials["Darker Gray"]}
        position={[-8.355, -2.085, -6.659]}
        rotation={[-Math.PI, 0.594, -Math.PI]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane078.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.419, -2.085, -6.811]}
        rotation={[0, 0.9, 0]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane079.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.205, -2.082, -6.993]}
        rotation={[0, 1.54, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane080.geometry}
        material={materials["Darker Gray"]}
        position={[-8.027, -2.085, -7.495]}
        rotation={[-Math.PI, 0.837, -Math.PI]}
        scale={[0.06, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane081.geometry}
        material={materials["Light Gray"]}
        position={[-7.288, -2.085, -7.587]}
        rotation={[-Math.PI, 0.031, -Math.PI]}
        scale={[0.043, 0.042, 0.042]}
      />
      <mesh
        geometry={nodes.Plane082.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-7.519, -2.085, -7.93]}
        rotation={[0, 1.223, 0]}
        scale={[0.043, 0.059, 0.059]}
      />
      <mesh
        geometry={nodes.Plane083.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-9.602, -2.085, -7.968]}
        rotation={[0, 0.671, 0]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane084.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-9.51, -2.076, -8.064]}
        rotation={[0, 0.132, 0]}
        scale={[0.073, 0.099, 0.099]}
      />
      <mesh
        geometry={nodes.Plane085.geometry}
        material={materials["Light Gray"]}
        position={[-9.367, -2.085, -7.674]}
        rotation={[0, 1.311, 0]}
        scale={[0.072, 0.07, 0.071]}
      />
      <mesh
        geometry={nodes.Plane086.geometry}
        material={materials["Darker Gray"]}
        position={[-6.6, -2.082, -6.136]}
        rotation={[0, -0.166, 0]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane087.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-7.124, -2.085, -6.102]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane088.geometry}
        material={materials["Dirty Beige 1"]}
        position={[-6.855, -2.085, -6.087]}
        rotation={[0, -0.539, 0]}
        scale={[0.073, 0.099, 0.099]}
      />
      <mesh
        geometry={nodes.Plane089.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.729, -2.082, -5.875]}
        rotation={[0, 0.64, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <group
        position={[-9.902, -2.394, -9.224]}
        rotation={[0, Math.PI / 2, 0]}
        scale={0.587}
      >
        <mesh
          geometry={nodes.Cube090.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube090_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube090_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <group
        position={[-9.902, -2.394, -7.807]}
        rotation={[0, Math.PI / 2, 0]}
        scale={0.587}
      >
        <mesh
          geometry={nodes.Cube097.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube097_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube097_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <group
        position={[-9.902, -2.394, -5.863]}
        rotation={[0, Math.PI / 2, 0]}
        scale={0.587}
      >
        <mesh
          geometry={nodes.Cube091.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube091_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube091_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <mesh
        geometry={nodes.FLB_Small_Vent_1.geometry}
        material={materials["Dark Gray"]}
        position={[-6.529, -2.088, -7.833]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={0.037}
      />
      <mesh
        geometry={nodes.FLB_Small_Vent_2.geometry}
        material={materials["Darker Gray"]}
        position={[-6.529, -2.088, -6.593]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={0.037}
      />
      <mesh
        geometry={nodes.FLB_Small_Vent_3.geometry}
        material={materials["Darker Gray"]}
        position={[-6.529, -2.088, -5.833]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={0.037}
      />
      <mesh
        geometry={nodes.FLB_Wire_1.geometry}
        material={materials.Black}
        position={[-8.836, -2.088, -6.723]}
        rotation={[Math.PI, -1.072, 0]}
        scale={[-0.048, -0.014, -0.011]}
      />
      <mesh
        geometry={nodes.FLB_Wire_2.geometry}
        material={materials.Black}
        position={[-9.072, -2.088, -6.36]}
        scale={[0.048, 0.014, 0.011]}
      />
      <group position={[10.882, -3.517, -10.768]} scale={1.399}>
        <mesh
          geometry={nodes.Cube048.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube048_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube048_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <group position={[13.566, 4.292, -23.333]} scale={2.035}>
        <mesh
          geometry={nodes.Cube049.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube049_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube049_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <group position={[9.999, -2.765, -9.861]}>
        <mesh
          geometry={nodes.Cylinder008_1.geometry}
          material={materials.Wood}
        />
        <mesh
          geometry={nodes.Cylinder008_2.geometry}
          material={materials.Black}
        />
        <mesh
          geometry={nodes.Cylinder008_3.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cylinder008_4.geometry}
          material={materials["Dirty Beige 1"]}
        />
        <mesh
          geometry={nodes.Cylinder008_5.geometry}
          material={materials["Dirty Beige 1.1"]}
        />
      </group>
      <mesh
        geometry={nodes.FRB_Small_Vent_1.geometry}
        material={materials["Dark Gray"]}
        position={[9.332, -2.089, -12.319]}
        rotation={[Math.PI, -Math.PI / 2, 0]}
        scale={-0.037}
      />
      <mesh
        geometry={nodes.FRB_Small_Vent_2.geometry}
        material={materials["Darker Gray"]}
        position={[9.332, -2.089, -11.078]}
        rotation={[Math.PI, -Math.PI / 2, 0]}
        scale={-0.037}
      />
      <mesh
        geometry={nodes.FRB_Small_Vent_3.geometry}
        material={materials["Darker Gray"]}
        position={[9.332, -2.089, -10.319]}
        rotation={[Math.PI, -Math.PI / 2, 0]}
        scale={-0.037}
      />
      <mesh
        geometry={nodes.FRB_Small_Exhaust_1.geometry}
        material={materials["Darker Gray"]}
        position={[12.499, -2.091, -11.004]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={[-0.11, -0.008, -0.11]}
      />
      <mesh
        geometry={nodes.FRB_Small_Exhaust_2.geometry}
        material={materials["Darker Gray"]}
        position={[12.499, -2.091, -10.337]}
        rotation={[0, -Math.PI / 2, 0]}
        scale={[-0.11, -0.008, -0.11]}
      />
      <mesh
        geometry={nodes.Plane090.geometry}
        material={materials["Darker Gray"]}
        position={[11.315, -2.083, -10.271]}
        rotation={[0, -0.74, 0]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane091.geometry}
        material={materials["Dirty Beige 2"]}
        position={[11.514, -2.086, -10.625]}
        rotation={[0, -0.574, 0]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane092.geometry}
        material={materials["Light Gray"]}
        position={[11.125, -2.086, -10.435]}
        rotation={[0, 0.066, 0]}
        scale={[0.072, 0.07, 0.071]}
      />
      <mesh
        geometry={nodes.Plane093.geometry}
        material={materials["Dirty Beige 2"]}
        position={[12.065, -2.083, -10.492]}
        rotation={[0, 0.066, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane094.geometry}
        material={materials["Dirty Beige 2"]}
        position={[11.922, -2.083, -11.111]}
        rotation={[0, -0.902, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane095.geometry}
        material={materials["Dirty Beige 2"]}
        position={[11.45, -2.083, -10.379]}
        rotation={[0, -0.574, 0]}
        scale={[0.051, 0.069, 0.069]}
      />
      <mesh
        geometry={nodes.Plane096.geometry}
        material={materials["Dirty Beige 2"]}
        position={[9.194, -2.086, -12.01]}
        rotation={[0, 0.93, -Math.PI]}
        scale={[-0.063, -0.042, -0.054]}
      />
      <mesh
        geometry={nodes.Plane097.geometry}
        material={materials["Dirty Beige 1"]}
        position={[9.51, -2.086, -12.102]}
        rotation={[-Math.PI, 0.323, 0]}
        scale={[-0.043, -0.059, -0.059]}
      />
      <group
        position={[-0.256, -2.895, -27.811]}
        rotation={[Math.PI / 2, 0, 0.183]}
        scale={[4.344, 3.865, 14.066]}
      >
        <mesh
          geometry={nodes.Oscorp_Building_Face.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Oscorp_Building_Face_1.geometry}
          material={materials["Dirty Purple 1"]}
        />
      </group>
      <group
        position={[-4.513, -7.815, -28.924]}
        rotation={[Math.PI / 2, 0, 0.183]}
        scale={[4.344, 3.865, 5.639]}
      >
        <mesh
          geometry={nodes.Oscorp_Building_Face003.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Oscorp_Building_Face003_1.geometry}
          material={materials["Blue Gray 4"]}
        />
        <mesh
          geometry={nodes.Oscorp_Building_Face003_2.geometry}
          material={materials["Blue Gray 3"]}
        />
      </group>
      <group
        position={[7.771, -7.85, -26.179]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[4.344, 3.865, 5.639]}
      >
        <mesh
          geometry={nodes.Oscorp_Building_Face004.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Oscorp_Building_Face004_1.geometry}
          material={materials["Blue Gray 4"]}
        />
        <mesh
          geometry={nodes.Oscorp_Building_Face004_2.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Oscorp_Building_Face004_3.geometry}
          material={materials["Blue Gray 3"]}
        />
      </group>
      <mesh
        geometry={nodes.Lines_Oscorp.geometry}
        material={materials.Black}
        position={[3.482, -12.01, -26.073]}
        scale={[0.135, 19.616, 0.135]}
      />
      <mesh
        geometry={nodes.Oscorp_Logo.geometry}
        material={materials["Oscorp Purple"]}
        position={[-1.253, -3.981, -27.853]}
        rotation={[0, 1.406, Math.PI / 2]}
        scale={[-0.057, -0.108, -0.171]}
      />
      <mesh
        geometry={nodes.LB_Wood_Plank.geometry}
        material={materials["Dirty Beige 1.1"]}
        position={[-2.383, 0.001, -0.081]}
        scale={[0.027, 0.01, 0.165]}
      />
      <mesh
        geometry={nodes.LB_Underlay.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-1.896, -0.011, -0.068]}
        scale={[-0.488, -0.005, -0.155]}
      />
      <mesh
        geometry={nodes.RB_Underlay.geometry}
        material={materials["Dirty Beige 2"]}
        position={[1.897, -0.011, -0.068]}
        scale={[-0.488, -0.005, -0.155]}
      />
      <mesh
        geometry={nodes.RB_Wood_Plank.geometry}
        material={materials["Dirty Beige 1.1"]}
        position={[1.41, 0.001, -0.081]}
        scale={[0.027, 0.01, 0.165]}
      />
      <mesh
        geometry={nodes.Backboard.geometry}
        material={materials["Insomniac Background"]}
        position={[4.9, -1.326, -10.774]}
        rotation={[0, -0.548, 0]}
      />
      <mesh
        geometry={nodes.Base_Bottom.geometry}
        material={materials.Wood}
        position={[4.9, -1.326, -10.774]}
        rotation={[0, -0.548, 0]}
      />
      <mesh
        geometry={nodes.Base_Top.geometry}
        material={materials.Wood}
        position={[4.9, -1.326, -10.774]}
        rotation={[0, -0.548, 0]}
      />
      <mesh
        geometry={nodes.Fence_Back.geometry}
        material={materials.Wood}
        position={[4.9, -1.326, -10.774]}
        rotation={[0, -0.548, 0]}
      />
      <mesh
        geometry={nodes.Fence_Back_Bottom.geometry}
        material={materials.Wood}
        position={[4.9, -1.326, -10.774]}
        rotation={[0, -0.548, 0]}
      />
      <mesh
        geometry={nodes.Fence_Front.geometry}
        material={materials.Wood}
        position={[4.9, -1.002, -10.774]}
        rotation={[0, -0.548, 0]}
        scale={[1, 0.743, 1]}
      />
      <mesh
        geometry={nodes.Fence_Front_Bottom.geometry}
        material={materials.Wood}
        position={[4.9, -1.326, -10.774]}
        rotation={[0, -0.548, 0]}
      />
      <mesh
        geometry={nodes.Lights.geometry}
        material={materials["Dark Gray"]}
        position={[4.9, -1.326, -10.774]}
        rotation={[0, -0.548, 0]}
      />
      <group position={[6.08, -2.693, -10.65]} scale={1.592}>
        <mesh
          geometry={nodes.Cube008.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube008_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube008_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <mesh
        geometry={nodes.Base_Bottom_Metal.geometry}
        material={materials["Darker Gray"]}
        position={[4.9, -2.395, -10.774]}
        rotation={[0, -0.548, 0]}
      />
      <mesh
        geometry={nodes.Insomniac_Exhaust_R.geometry}
        material={materials["Darker Gray"]}
        position={[5.116, -1.101, -8.834]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={[-0.11, -0.008, -0.11]}
      />
      <mesh
        geometry={nodes.Insomniac_Exhaust_L.geometry}
        material={materials["Darker Gray"]}
        position={[4.449, -1.101, -8.834]}
        rotation={[Math.PI, 0, Math.PI]}
        scale={[-0.11, -0.008, -0.11]}
      />
      <group position={[7.628, -1.412, -12.166]} scale={0.587}>
        <mesh
          geometry={nodes.Cube011.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube011_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube011_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <group position={[6.21, -1.412, -12.166]} scale={0.587}>
        <mesh
          geometry={nodes.Cube016.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube016_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube016_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <mesh
        geometry={nodes.Insomniac_Wire_3.geometry}
        material={materials.Black}
        position={[5.127, -1.073, -11.1]}
        rotation={[-Math.PI, 0.499, 0]}
        scale={[-0.048, -0.014, -0.011]}
      />
      <mesh
        geometry={nodes.Insomniac_Wire_2.geometry}
        material={materials.Black}
        position={[4.763, -1.073, -11.284]}
        rotation={[0, -1.523, 0]}
        scale={[0.048, 0.014, 0.011]}
      />
      <mesh
        geometry={nodes.Insomniac_Wire_1.geometry}
        material={materials.Black}
        position={[6.667, -1.073, -9.542]}
        rotation={[-Math.PI, 0.499, 0]}
        scale={[-0.048, -0.014, -0.011]}
      />
      <mesh
        geometry={nodes.Insomniac_Wire_3001.geometry}
        material={materials.Black}
        position={[4.568, 0.964, -10.941]}
        rotation={[-2.761, -0.961, -1.215]}
        scale={[-0.048, -0.014, -0.011]}
      />
      <mesh
        geometry={nodes.Insomniac_Wire_2001.geometry}
        material={materials.Black}
        position={[4.459, 0.528, -11.007]}
        rotation={[2.038, -0.56, 0.759]}
        scale={[0.048, 0.014, 0.011]}
      />
      <mesh
        geometry={nodes.Insomniac_Wire_1001.geometry}
        material={materials.Black}
        position={[7.173, 0.52, -9.322]}
        rotation={[-1.729, -0.295, -0.596]}
        scale={[-0.048, -0.014, -0.011]}
      />
      <mesh
        geometry={nodes.Plane098.geometry}
        material={materials["Darker Gray"]}
        position={[4.382, -1.093, -10.018]}
        rotation={[Math.PI, -0.83, Math.PI]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane099.geometry}
        material={materials["Dirty Beige 2"]}
        position={[4.736, -1.096, -9.82]}
        rotation={[Math.PI, -0.997, Math.PI]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane100.geometry}
        material={materials["Light Gray"]}
        position={[4.546, -1.096, -10.208]}
        rotation={[0, -1.505, 0]}
        scale={[0.072, 0.07, 0.071]}
      />
      <mesh
        geometry={nodes.Plane101.geometry}
        material={materials["Dirty Beige 2"]}
        position={[4.604, -1.093, -9.268]}
        rotation={[0, -1.505, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane102.geometry}
        material={materials["Dirty Beige 2"]}
        position={[5.223, -1.093, -9.411]}
        rotation={[Math.PI, -0.669, Math.PI]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane103.geometry}
        material={materials["Dirty Beige 2"]}
        position={[4.49, -1.093, -9.883]}
        rotation={[Math.PI, -0.997, Math.PI]}
        scale={[0.051, 0.069, 0.069]}
      />
      <mesh
        geometry={nodes.Plane104.geometry}
        material={materials["Darker Gray"]}
        position={[5.498, -1.093, -11.977]}
        rotation={[Math.PI, -0.309, Math.PI]}
        scale={[0.105, 0.102, 0.104]}
      />
      <mesh
        geometry={nodes.Plane105.geometry}
        material={materials["Dirty Beige 2"]}
        position={[6.652, -1.096, -11.429]}
        rotation={[Math.PI, -0.088, Math.PI]}
        scale={[0.103, 0.138, 0.138]}
      />
      <mesh
        geometry={nodes.Plane106.geometry}
        material={materials["Light Gray"]}
        position={[5.332, -1.096, -12.131]}
        rotation={[Math.PI, -0.927, Math.PI]}
        scale={[0.074, 0.073, 0.074]}
      />
      <mesh
        geometry={nodes.Plane107.geometry}
        material={materials["Dirty Beige 2"]}
        position={[6.144, -1.093, -11.2]}
        rotation={[Math.PI, -1.115, Math.PI]}
        scale={[0.109, 0.073, 0.095]}
      />
      <mesh
        geometry={nodes.Plane108.geometry}
        material={materials["Dirty Beige 2"]}
        position={[6.774, -1.093, -11.008]}
        rotation={[Math.PI, -0.147, Math.PI]}
        scale={[0.109, 0.073, 0.095]}
      />
      <mesh
        geometry={nodes.Plane109.geometry}
        material={materials["Dirty Beige 2"]}
        position={[6.359, -1.093, -11.811]}
        rotation={[Math.PI, -0.475, Math.PI]}
        scale={[0.053, 0.071, 0.071]}
      />
      <mesh
        geometry={nodes.Plane110.geometry}
        material={materials["Darker Gray"]}
        position={[6.899, -1.093, -11.654]}
        rotation={[Math.PI, -0.446, Math.PI]}
        scale={[0.105, 0.102, 0.104]}
      />
      <mesh
        geometry={nodes.Plane111.geometry}
        material={materials["Dirty Beige 2"]}
        position={[7.162, -1.096, -10.813]}
        rotation={[Math.PI, -0.613, Math.PI]}
        scale={[0.103, 0.138, 0.138]}
      />
      <mesh
        geometry={nodes.Plane112.geometry}
        material={materials["Light Gray"]}
        position={[7.515, -1.096, -11.796]}
        rotation={[Math.PI, -1.253, Math.PI]}
        scale={[0.074, 0.073, 0.074]}
      />
      <mesh
        geometry={nodes.Plane113.geometry}
        material={materials["Dirty Beige 2"]}
        position={[7.088, -1.093, -11.103]}
        rotation={[Math.PI, -1.253, Math.PI]}
        scale={[0.109, 0.073, 0.095]}
      />
      <mesh
        geometry={nodes.Plane114.geometry}
        material={materials["Dirty Beige 2"]}
        position={[7.542, -1.093, -10.685]}
        rotation={[Math.PI, -0.285, Math.PI]}
        scale={[0.109, 0.073, 0.095]}
      />
      <mesh
        geometry={nodes.Plane115.geometry}
        material={materials["Dirty Beige 2"]}
        position={[7.253, -1.093, -11.354]}
        rotation={[Math.PI, -0.321, Math.PI]}
        scale={[0.053, 0.071, 0.071]}
      />
      <mesh
        geometry={nodes.Plane116.geometry}
        material={materials["Dirty Beige 2"]}
        position={[4.228, -1.095, -12.105]}
        rotation={[-Math.PI, 0.02, -Math.PI]}
        scale={[0.074, 0.1, 0.1]}
      />
      <mesh
        geometry={nodes.Plane117.geometry}
        material={materials["Dirty Beige 2"]}
        position={[4.159, -1.093, -11.635]}
        rotation={[-Math.PI, 0.348, -Math.PI]}
        scale={[0.079, 0.052, 0.068]}
      />
      <mesh
        geometry={nodes.Plane118.geometry}
        material={materials["Darker Gray"]}
        position={[5.801, -1.093, -11.943]}
        rotation={[-Math.PI, 0.708, -Math.PI]}
        scale={[0.078, 0.077, 0.078]}
      />
      <mesh
        geometry={nodes.Plane119.geometry}
        material={materials["Dirty Beige 2"]}
        position={[5.699, -1.093, -11.856]}
        rotation={[-Math.PI, 0.542, -Math.PI]}
        scale={[0.039, 0.053, 0.053]}
      />
      <mesh
        geometry={nodes.Plane120.geometry}
        material={materials["Darker Gray"]}
        position={[5.811, -1.093, -11.452]}
        rotation={[-Math.PI, 0.571, -Math.PI]}
        scale={[0.078, 0.077, 0.078]}
      />
      <mesh
        geometry={nodes.Plane121.geometry}
        material={materials["Darker Gray"]}
        position={[5.292, -1.076, -10.65]}
        rotation={[Math.PI, -0.83, Math.PI]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane122.geometry}
        material={materials["Dirty Beige 2"]}
        position={[5.646, -1.079, -10.451]}
        rotation={[Math.PI, -0.997, Math.PI]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane123.geometry}
        material={materials["Dirty Beige 2"]}
        position={[6.061, -1.076, -9.565]}
        rotation={[0, -0.858, 0]}
        scale={[0.093, 0.062, 0.08]}
      />
      <mesh
        geometry={nodes.Plane124.geometry}
        material={materials["Dirty Beige 2"]}
        position={[6.093, -1.076, -10.054]}
        rotation={[Math.PI, -1.316, Math.PI]}
        scale={[0.093, 0.062, 0.08]}
      />
      <mesh
        geometry={nodes.Plane125.geometry}
        material={materials["Dirty Beige 2"]}
        position={[5.4, -1.076, -10.514]}
        rotation={[Math.PI, -0.997, Math.PI]}
        scale={[0.051, 0.069, 0.069]}
      />
      <mesh
        geometry={nodes.Plane126.geometry}
        material={materials["Darker Gray"]}
        position={[6.565, -1.076, -10.135]}
        rotation={[Math.PI, -0.602, Math.PI]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane127.geometry}
        material={materials["Dirty Beige 2"]}
        position={[6.865, -1.079, -9.861]}
        rotation={[Math.PI, -0.768, Math.PI]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane128.geometry}
        material={materials["Dirty Beige 2"]}
        position={[6.794, -1.076, -9.824]}
        rotation={[0, -1.087, 0]}
        scale={[0.093, 0.062, 0.08]}
      />
      <mesh
        geometry={nodes.Plane129.geometry}
        material={materials["Dirty Beige 2"]}
        position={[7.246, -1.076, -9.353]}
        rotation={[Math.PI, -0.44, Math.PI]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane130.geometry}
        material={materials["Dirty Beige 2"]}
        position={[6.64, -1.076, -9.979]}
        rotation={[Math.PI, -0.768, Math.PI]}
        scale={[0.051, 0.069, 0.069]}
      />
      <mesh
        geometry={nodes.Plane164.geometry}
        material={materials["Darker Gray"]}
        position={[-6.402, -3.244, -21.044]}
        rotation={[0, -0.74, 0]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane165.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.203, -3.246, -21.398]}
        rotation={[0, -0.574, 0]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane166.geometry}
        material={materials["Light Gray"]}
        position={[-6.591, -3.246, -21.208]}
        rotation={[0, 0.066, 0]}
        scale={[0.072, 0.07, 0.071]}
      />
      <mesh
        geometry={nodes.Plane167.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-5.652, -3.244, -21.266]}
        rotation={[0, 0.066, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane168.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-5.795, -3.244, -21.885]}
        rotation={[0, -0.902, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane169.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.266, -3.243, -21.152]}
        rotation={[0, -0.574, 0]}
        scale={[0.051, 0.069, 0.069]}
      />
      <mesh
        geometry={nodes.Plane170.geometry}
        material={materials["Darker Gray"]}
        position={[-8.36, -3.244, -22.159]}
        rotation={[0, -1.262, 0]}
        scale={[0.105, 0.102, 0.104]}
      />
      <mesh
        geometry={nodes.Plane171.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-7.813, -3.247, -23.314]}
        rotation={[0, -1.482, 0]}
        scale={[0.103, 0.138, 0.138]}
      />
      <mesh
        geometry={nodes.Plane172.geometry}
        material={materials["Light Gray"]}
        position={[-8.514, -3.247, -21.994]}
        rotation={[0, -0.644, 0]}
        scale={[0.074, 0.073, 0.074]}
      />
      <mesh
        geometry={nodes.Plane173.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-7.583, -3.244, -22.805]}
        rotation={[0, -0.455, 0]}
        scale={[0.109, 0.073, 0.095]}
      />
      <mesh
        geometry={nodes.Plane174.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-7.391, -3.244, -23.436]}
        rotation={[0, -1.424, 0]}
        scale={[0.109, 0.073, 0.095]}
      />
      <mesh
        geometry={nodes.Plane175.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-8.195, -3.243, -23.021]}
        rotation={[0, -1.096, 0]}
        scale={[0.053, 0.071, 0.071]}
      />
      <mesh
        geometry={nodes.Plane176.geometry}
        material={materials["Darker Gray"]}
        position={[-8.038, -3.244, -23.561]}
        rotation={[0, -1.124, 0]}
        scale={[0.105, 0.102, 0.104]}
      />
      <mesh
        geometry={nodes.Plane177.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-7.197, -3.247, -23.824]}
        rotation={[0, -0.958, 0]}
        scale={[0.103, 0.138, 0.138]}
      />
      <mesh
        geometry={nodes.Plane178.geometry}
        material={materials["Light Gray"]}
        position={[-8.18, -3.247, -24.176]}
        rotation={[0, -0.318, 0]}
        scale={[0.074, 0.073, 0.074]}
      />
      <mesh
        geometry={nodes.Plane179.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-7.486, -3.244, -23.75]}
        rotation={[0, -0.318, 0]}
        scale={[0.109, 0.073, 0.095]}
      />
      <mesh
        geometry={nodes.Plane180.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-7.069, -3.244, -24.203]}
        rotation={[0, -1.286, 0]}
        scale={[0.109, 0.073, 0.095]}
      />
      <mesh
        geometry={nodes.Plane181.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-7.737, -3.243, -23.915]}
        rotation={[0, -1.25, 0]}
        scale={[0.053, 0.071, 0.071]}
      />
      <mesh
        geometry={nodes.Plane182.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-8.488, -3.246, -20.889]}
        rotation={[Math.PI, -1.551, Math.PI]}
        scale={[0.074, 0.1, 0.1]}
      />
      <mesh
        geometry={nodes.Plane183.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-8.019, -3.244, -20.821]}
        rotation={[Math.PI, -1.223, Math.PI]}
        scale={[0.079, 0.052, 0.068]}
      />
      <mesh
        geometry={nodes.Plane184.geometry}
        material={materials["Darker Gray"]}
        position={[-8.327, -3.244, -22.463]}
        rotation={[Math.PI, -0.862, Math.PI]}
        scale={[0.078, 0.077, 0.078]}
      />
      <mesh
        geometry={nodes.Plane185.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-8.239, -3.243, -22.361]}
        rotation={[Math.PI, -1.029, Math.PI]}
        scale={[0.039, 0.053, 0.053]}
      />
      <mesh
        geometry={nodes.Plane186.geometry}
        material={materials["Darker Gray"]}
        position={[-7.835, -3.244, -22.473]}
        rotation={[Math.PI, -1, Math.PI]}
        scale={[0.078, 0.077, 0.078]}
      />
      <mesh
        geometry={nodes.Plane187.geometry}
        material={materials["Darker Gray"]}
        position={[-7.033, -3.227, -21.954]}
        rotation={[0, -0.74, 0]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane188.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.834, -3.229, -22.308]}
        rotation={[0, -0.574, 0]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane189.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-5.949, -3.227, -22.723]}
        rotation={[0, 0.713, 0]}
        scale={[0.093, 0.062, 0.08]}
      />
      <mesh
        geometry={nodes.Plane190.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.438, -3.227, -22.755]}
        rotation={[0, -0.255, 0]}
        scale={[0.093, 0.062, 0.08]}
      />
      <mesh
        geometry={nodes.Plane191.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.898, -3.226, -22.062]}
        rotation={[0, -0.574, 0]}
        scale={[0.051, 0.069, 0.069]}
      />
      <mesh
        geometry={nodes.Plane192.geometry}
        material={materials["Darker Gray"]}
        position={[-6.519, -3.227, -23.227]}
        rotation={[0, -0.969, 0]}
        scale={[0.101, 0.099, 0.1]}
      />
      <mesh
        geometry={nodes.Plane193.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.245, -3.229, -23.527]}
        rotation={[0, -0.803, 0]}
        scale={[0.099, 0.133, 0.133]}
      />
      <mesh
        geometry={nodes.Plane194.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.208, -3.227, -23.455]}
        rotation={[0, 0.484, 0]}
        scale={[0.093, 0.062, 0.08]}
      />
      <mesh
        geometry={nodes.Plane195.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-5.737, -3.227, -23.908]}
        rotation={[0, -1.131, 0]}
        scale={[0.105, 0.07, 0.091]}
      />
      <mesh
        geometry={nodes.Plane196.geometry}
        material={materials["Dirty Beige 2"]}
        position={[-6.362, -3.226, -23.301]}
        rotation={[0, -0.803, 0]}
        scale={[0.051, 0.069, 0.069]}
      />
      <mesh
        geometry={nodes.Insomniac_Exhaust_L002.geometry}
        material={materials["Darker Gray"]}
        position={[-5.217, -3.251, -21.111]}
        rotation={[0, -1.571, 0]}
        scale={[-0.11, -0.008, -0.11]}
      />
      <mesh
        geometry={nodes.Insomniac_Exhaust_R002.geometry}
        material={materials["Darker Gray"]}
        position={[-5.217, -3.251, -21.778]}
        rotation={[0, -1.571, 0]}
        scale={[-0.11, -0.008, -0.11]}
      />
      <group
        position={[-8.549, -3.562, -22.872]}
        rotation={[0, 1.57, 0]}
        scale={0.587}
      >
        <mesh
          geometry={nodes.Cube035.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube035_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube035_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <group
        position={[-8.549, -3.562, -24.29]}
        rotation={[0, 1.57, 0]}
        scale={0.587}
      >
        <mesh
          geometry={nodes.Cube033.geometry}
          material={materials["Dark Gray"]}
        />
        <mesh
          geometry={nodes.Cube033_1.geometry}
          material={materials["Darker Gray"]}
        />
        <mesh
          geometry={nodes.Cube033_2.geometry}
          material={materials["Light Gray"]}
        />
      </group>
      <mesh
        geometry={nodes.Insomniac_Wire_1003.geometry}
        material={materials.Black}
        position={[-5.926, -3.224, -23.329]}
        rotation={[Math.PI, -1.072, 0]}
        scale={[-0.048, -0.014, -0.011]}
      />
      <mesh
        geometry={nodes.Insomniac_Wire_2003.geometry}
        material={materials.Black}
        position={[-7.667, -3.224, -21.425]}
        rotation={[0, 0.048, 0]}
        scale={[0.048, 0.014, 0.011]}
      />
      <mesh
        geometry={nodes.Insomniac_Wire_3003.geometry}
        material={materials.Black}
        position={[-7.483, -3.224, -21.789]}
        rotation={[Math.PI, -1.072, 0]}
        scale={[-0.048, -0.014, -0.011]}
      />
      <mesh
        geometry={nodes.Backboard002.geometry}
        material={materials["Insomniac Background"]}
        position={[-7.157, -3.477, -21.562]}
        rotation={[0, 1.023, 0]}
      />
      <mesh
        geometry={nodes.Base_Bottom002.geometry}
        material={materials.Wood}
        position={[-7.157, -3.477, -21.562]}
        rotation={[0, 1.023, 0]}
      />
      <mesh
        geometry={nodes.Base_Bottom_Metal002.geometry}
        material={materials["Darker Gray"]}
        position={[-7.157, -4.545, -21.562]}
        rotation={[0, 1.023, 0]}
      />
      <mesh
        geometry={nodes.Base_Top002.geometry}
        material={materials.Wood}
        position={[-7.157, -3.477, -21.562]}
        rotation={[0, 1.023, 0]}
      />
      <mesh
        geometry={nodes.Fence_Back_Bottom002.geometry}
        material={materials.Wood}
        position={[-7.157, -3.477, -21.562]}
        rotation={[0, 1.023, 0]}
      />
      <mesh
        geometry={nodes.Fence_Front002.geometry}
        material={materials.Wood}
        position={[-7.157, -3.477, -21.562]}
        rotation={[0, 1.023, 0]}
      />
      <mesh
        geometry={nodes.Fence_Front_Bottom002.geometry}
        material={materials.Wood}
        position={[-7.157, -3.477, -21.562]}
        rotation={[0, 1.023, 0]}
      />
      <mesh
        geometry={nodes.Games002.geometry}
        material={materials.White}
        position={[-7.157, -3.477, -21.562]}
        rotation={[0, 1.023, 0]}
      />
      <mesh
        geometry={nodes.Hello001.geometry}
        material={materials.White}
        position={[-7.157, -3.477, -21.562]}
        rotation={[0, 1.023, 0]}
      />
      <group position={[-7.157, -3.477, -21.562]} rotation={[0, 1.023, 0]}>
        <mesh geometry={nodes.Plane231.geometry} material={materials.Red} />
        <mesh geometry={nodes.Plane231_1.geometry} material={materials.White} />
      </group>
      <group
        position={[-7.034, -4.843, -22.742]}
        rotation={[0, Math.PI / 2, 0]}
        scale={1.592}
      >
        <mesh
          geometry={nodes.Cube042.geometry}
          material={materials["Blue Gray 1"]}
        />
        <mesh
          geometry={nodes.Cube042_1.geometry}
          material={materials["Almost Black"]}
        />
        <mesh
          geometry={nodes.Cube042_2.geometry}
          material={materials["Blue Gray 2"]}
        />
      </group>
      <mesh
        geometry={nodes.Lights002.geometry}
        material={materials["Dark Gray"]}
        position={[-7.157, -3.477, -21.562]}
        rotation={[0, 1.023, 0]}
      />
      <mesh
        geometry={nodes.Oscorp_Logo001.geometry}
        material={materials.White}
        position={[7.074, 0.983, -9.436]}
        rotation={[1.535, -0.02, 0.55]}
        scale={[-0.003, -0.005, -0.008]}
      />
      <group
        position={[-7.317, 0.107, -3.071]}
        rotation={[0, -0.57, 0]}
        scale={1.208}
      >
        <mesh
          geometry={nodes.Plane024_1.geometry}
          material={materials["Insomniac O"]}
        />
        <mesh geometry={nodes.Plane024_2.geometry} material={materials.White} />
        <mesh geometry={nodes.Plane024_3.geometry} material={materials.Red} />
      </group>
      <mesh
        geometry={nodes.Cylinder.geometry}
        material={materials.Black}
        position={[8.241, -6.654, -23.44]}
        scale={[0.578, 16.487, 0.578]}
      />
      <mesh
        geometry={nodes.Cylinder006.geometry}
        material={materials.Black}
        position={[-7.568, -2.91, -27.566]}
        rotation={[0, -0.31, 0]}
        scale={[0.613, 17.491, 0.613]}
      />
      <mesh
        geometry={nodes.Cylinder008.geometry}
        material={materials.Black}
        position={[-9.574, 0.821, -18.001]}
        scale={[0.817, 23.322, 0.817]}
      />
      <mesh
        geometry={nodes.Cylinder012.geometry}
        material={materials.Black}
        position={[9.427, 3.067, -5.558]}
        rotation={[-0.708, 0.365, 0.876]}
        scale={[0.338, 9.635, 0.338]}
      />
      <mesh
        geometry={nodes.Cylinder022.geometry}
        material={materials.Black}
        position={[10.533, -4.351, -14.278]}
        rotation={[0, 1.106, 0]}
        scale={[0.52, 14.826, 0.52]}
      />
      <mesh
        geometry={nodes.Cylinder027.geometry}
        material={materials.Black}
        position={[-8.293, -2.395, -29.227]}
        rotation={[0, 0.566, 0]}
        scale={[0.407, 11.61, 0.407]}
      />
      <mesh
        geometry={nodes.Cylinder031.geometry}
        material={materials.Black}
        position={[-7.961, -7.936, -27.795]}
        rotation={[-Math.PI, 0, 0]}
        scale={[-0.509, -14.528, -0.509]}
      />
      <mesh
        geometry={nodes.Cylinder032.geometry}
        material={materials.Black}
        position={[-9.231, -9.418, -27.372]}
        rotation={[0, -0.31, 0]}
        scale={[0.454, 12.967, 0.454]}
      />
      <mesh
        geometry={nodes.Cylinder033.geometry}
        material={materials.Black}
        position={[-7.626, -9.418, -28.353]}
        rotation={[0, -0.31, 0]}
        scale={[0.312, 8.905, 0.312]}
      />
      <mesh
        geometry={nodes.Cylinder034.geometry}
        material={materials.Black}
        position={[-8.538, -7.936, -27.795]}
        scale={[0.509, 14.528, 0.509]}
      />
      <mesh
        geometry={nodes.Cylinder035.geometry}
        material={materials.Black}
        position={[-8.644, -4.138, -27.795]}
        scale={[0.648, 18.503, 0.648]}
      />
      <mesh
        geometry={nodes.Cylinder036.geometry}
        material={materials.Black}
        position={[-7.78, -6.421, -27.795]}
        scale={[0.604, 17.237, 0.604]}
      />
      <mesh
        geometry={nodes.Cylinder044.geometry}
        material={materials.Black}
        position={[12.545, -0.297, -19.494]}
        rotation={[0, 0.623, 0]}
        scale={[0.43, 12.264, 0.43]}
      />
      <mesh
        geometry={nodes.Cylinder001.geometry}
        material={materials.Black}
        position={[0.423, -10.808, -23.89]}
        rotation={[0.381, 0.948, -0.418]}
        scale={[0.488, 13.923, 0.488]}
      />
      <mesh
        geometry={nodes.Cylinder002.geometry}
        material={materials.Black}
        position={[0.423, -12.488, -23.89]}
        rotation={[-2.761, 0.948, -0.418]}
        scale={[-0.406, -11.58, -0.406]}
      />
      <mesh
        geometry={nodes.Cylinder003.geometry}
        material={materials.Black}
        position={[5.964, 1.007, -15.23]}
        rotation={[-1.491, 0.601, 1.71]}
        scale={[0.197, 5.618, 0.197]}
      />
      <mesh
        geometry={nodes.Cylinder004.geometry}
        material={materials.Black}
        position={[-3.5, 0.631, -26.179]}
        rotation={[-0.098, -0.205, -0.614]}
        scale={[0.339, 9.663, 0.339]}
      />
      <mesh
        geometry={nodes.Cylinder005.geometry}
        material={materials.Black}
        position={[-6.501, 1.184, -11.949]}
        rotation={[-0.306, -1.247, -0.885]}
        scale={[0.408, 11.654, 0.408]}
      />
      <mesh
        geometry={nodes.Cylinder007.geometry}
        material={materials.Black}
        position={[1.568, -1.493, -23.967]}
        rotation={[3.074, 1.094, 0.11]}
        scale={[-0.194, -5.549, -0.194]}
      />
      <mesh
        geometry={nodes.Cylinder009.geometry}
        material={materials.Black}
        position={[-10.716, -2.92, -3.41]}
        rotation={[0.856, 0.818, -1.006]}
        scale={[0.52, 14.826, 0.52]}
      />
      <mesh
        geometry={nodes.Cylinder010.geometry}
        material={materials.Black}
        position={[-19.155, -5.273, -34.988]}
        rotation={[-2.761, 0.948, -0.418]}
        scale={[-0.956, -27.281, -0.956]}
      />
      <mesh
        geometry={nodes.Cylinder011.geometry}
        material={materials.Black}
        position={[-19.155, -8.565, -34.988]}
        rotation={[0.381, 0.948, -0.418]}
        scale={[0.795, 22.691, 0.795]}
      />
      <mesh
        geometry={nodes.Cylinder013.geometry}
        material={materials.Black}
        position={[-19.155, -13.16, -34.988]}
        rotation={[-0.323, 1.172, 0.38]}
        scale={[0.795, 22.691, 0.795]}
      />
      <mesh
        geometry={nodes.Cylinder014.geometry}
        material={materials.Black}
        position={[4.3, 7.661, -24.252]}
        rotation={[-2.321, -0.495, -1.795]}
        scale={[-0.194, -5.549, -0.194]}
      />
      <mesh
        geometry={nodes.Cylinder015.geometry}
        material={materials.Black}
        position={[21.755, -4.863, -26.77]}
        rotation={[-1.035, 1.316, -2.224]}
        scale={[-0.956, -27.281, -0.956]}
      />
      <mesh
        geometry={nodes.Cylinder016.geometry}
        material={materials.Black}
        position={[21.755, -8.155, -26.77]}
        rotation={[0.226, 0.256, -0.162]}
        scale={[0.795, 22.691, 0.795]}
      />
      <mesh
        geometry={nodes.Cylinder017.geometry}
        material={materials.Black}
        position={[21.755, -12.75, -26.77]}
        rotation={[-0.139, 0.467, 0.144]}
        scale={[0.795, 22.691, 0.795]}
      />
      <mesh
        geometry={nodes.Cylinder018.geometry}
        material={materials.Black}
        position={[-27.498, -4.718, -37.132]}
        rotation={[0, 1.226, 0]}
        scale={[0.641, 18.302, 0.641]}
      />
      <mesh
        geometry={nodes.Cylinder019.geometry}
        material={materials.Black}
        position={[-25.8, 0.286, -43.821]}
        rotation={[0, 0.743, 0]}
        scale={[0.531, 15.139, 0.531]}
      />
    </group>
  );
}

export default Model;

useGLTF.preload("models/oscorp_scene_venom.glb");
